import { motion } from "framer-motion";
import { CATEGORIES } from "@/data/content";
import * as Icons from "lucide-react";

const SectionHead = ({ eyebrow, title, sub }) => (
  <div className="mb-14 max-w-2xl">
    <div className="font-mono-lux text-[11px] tracking-[0.3em] text-amber-400 uppercase mb-3">
      {eyebrow}
    </div>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-700 text-amber-50">
      {title}
    </h2>
    {sub && <p className="text-zinc-400 mt-4 text-base leading-relaxed">{sub}</p>}
  </div>
);

export const Categories = () => (
  <section id="categories" className="relative py-24 px-5 sm:px-8 bg-[#09090B]">
    <div className="max-w-7xl mx-auto">
      <SectionHead
        eyebrow="Four Prestigious Honours"
        title="Award Categories"
        sub="Recognising the icons who redefine excellence across leadership, enterprise, society and the future."
      />
      <div className="grid md:grid-cols-2 gap-6">
        {CATEGORIES.map((c, i) => {
          const Icon = Icons[c.icon] || Icons.Award;
          return (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="card-lux rounded-2xl p-8 relative overflow-hidden group"
              data-testid={`category-card-${c.id}`}
            >
              <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-amber-500/5 blur-2xl group-hover:bg-amber-500/10 transition-all" />
              <div className="flex items-start justify-between">
                <div className="w-14 h-14 rounded-xl gold-gradient-bg flex items-center justify-center">
                  <Icon className="w-7 h-7 text-black" strokeWidth={1.8} />
                </div>
                <span className="font-mono-lux text-[10px] tracking-[0.2em] text-amber-400 uppercase px-3 py-1 rounded-full border border-amber-500/25">
                  {c.badge}
                </span>
              </div>
              <h3 className="font-serif-lux text-2xl font-600 text-amber-50 mt-6 leading-tight">
                {c.title}
              </h3>
              <p className="text-zinc-400 mt-3 leading-relaxed">{c.subtitle}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export { SectionHead };
